import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)
import { CachedApi } from './CachedApi'

export class ShipmentZonesApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
		this.access_token = container.get('services.oauth').getToken()
	}

	get (params) {

		let c = new CachedApi();

		params.source = container.get('source').getValue()

		return c.get(this.url + '/localization/zones', params);
	}
	
	coverage (params) {
		
		return Vue.http.get(this.url + '/localization/coverage', { params: params, headers: { Authorization: 'Bearer ' + this.access_token } })
	}

	points (params) {
		this.url = process.env.NODE_ENV === 'development'
			? 'https://sigma.quomi.it:8214/v1'
   			: process.env.VUE_APP_API_URL
		
		var query = params && params.zip_code ? `and address.zip_code='${params.zip_code}'` : ''
		var show = 9999999
		if (params && params.bounds) {
			query = query + `and address.geolocation.latitude<${params.bounds.lat0} and address.geolocation.latitude>${params.bounds.lat1} and address.geolocation.longitude<${params.bounds.lng0} and address.geolocation.longitude>${params.bounds.lng1}`
		}
		return Vue.http.get(this.url + "/ore/delivery-points?include=address,vendor,address.geolocation,openingHours&query=code ct 'FP' " + query, { params: { show: show } })
	}
};
